import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { BranchesService } from 'src/app/services/branches.service';
import { GoogleMapsLoaderService } from 'src/app/services/google-maps-loader.service';

@Component({
  selector: 'divisas-capital-sucursales',
  templateUrl: './sucursales.component.html',
  styleUrls: ['./sucursales.component.scss'],
})
export class SucursalesComponent implements OnInit, AfterViewInit {
  @ViewChild('map') mapElement: any;
  map: google.maps.Map | undefined;
  marker: google.maps.marker.AdvancedMarkerElement | undefined;

  public sucursales: any;
  public customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: false,
    navSpeed: 700,
    navText: [
      '<i class="fa fa-angle-left" aria-hidden="true"></i>',
      '<i class="fa fa-angle-right" aria-hidden="true"></i>',
    ],
    nav: false,
    responsive: {
      0: {
        items: 1,
      },
    },
  };
  sucursalSelectet = 0;
  private mapRequestId = 0;
  private pendingBranch: any = null;
  private viewReady = false;

  constructor(
    private readonly branchesService: BranchesService,
    private readonly googleMapsLoader: GoogleMapsLoaderService,
    private readonly cdr: ChangeDetectorRef,
  ) {
    this.branchesService.getAll().subscribe((branches: any) => {
      this.sucursales = branches;

      this.branchesService.getBranchSelected().subscribe((branch: any) => {
        if (branch) {
          void this.setMap(branch);
          this.sucursalSelectet = this.sucursales.findIndex(
            ({ id }: any) => id === branch.id
          );
        }
      });
    });
  }

  ngAfterViewInit(): void {
    this.viewReady = true;
    if (this.pendingBranch) {
      const branch = this.pendingBranch;
      this.pendingBranch = null;
      void this.setMap(branch);
    }
  }

  getBranchPhone() {
    return this.sucursales[this.sucursalSelectet].contacts.find(
      (contact: any) => contact.type === 'PHONE'
    )?.value;
  }

  getBranchWhatsapp() {
    return this.sucursales[this.sucursalSelectet].contacts.find(
      (contact: any) => contact.type === 'WHATSAPP'
    )?.value;
  }

  getBranchEmail() {
    return this.sucursales[this.sucursalSelectet].contacts.find(
      (contact: any) => contact.type === 'EMAIL'
    )?.value;
  }

  async setMap(sucursal: any): Promise<void> {
    if (!sucursal?.address) {
      return;
    }

    if (!this.viewReady || !this.mapElement?.nativeElement) {
      this.pendingBranch = sucursal;
      return;
    }

    const requestId = ++this.mapRequestId;
    this.cdr.detectChanges();

    const element = this.mapElement.nativeElement as HTMLElement;

    try {
      if (this.marker) {
        this.marker.map = null;
        this.marker = undefined;
      }

      const { map, marker } = await this.googleMapsLoader.createBranchMap({
        element,
        latitude: Number(sucursal.address.latitude),
        longitude: Number(sucursal.address.longitude),
      });

      if (requestId !== this.mapRequestId) {
        marker.map = null;
        return;
      }

      this.map = map;
      this.marker = marker;
    } catch (error) {
      console.error('Error al inicializar el mapa de sucursales:', error);
    }
  }

  ngOnInit() {}

  selectSucursal(index: any) {
    if (!this.sucursales) return;
    void this.setMap(this.sucursales[index]);
    this.sucursalSelectet = index;
    this.customOptions.startPosition = index;
  }
}
